import React, { useRef, useState } from 'react';
import { Upload, FileText, X } from 'lucide-react';

export const CvUpload = ({ file, onChange, disabled }) => {
  const input = useRef(null);
  const [error, setError] = useState('');
  const choose = (candidate) => {
    setError('');
    if (!candidate) return;
    if (!/\.(pdf|doc|docx)$/i.test(candidate.name) || !candidate.size || candidate.size > 5 * 1024 * 1024) {
      setError('Sélectionnez un fichier PDF, DOC ou DOCX non vide, de 5 Mo maximum.');
      if (input.current) input.current.value = '';
      onChange(null);
      return;
    }
    onChange(candidate);
  };
  return (
    <div>
      <label htmlFor="cv-file" className="block text-sm font-medium text-gray-700 mb-2">Votre CV *</label>
      <div data-testid="cv-drop-zone" onDragOver={event => event.preventDefault()} onDrop={event => { event.preventDefault(); if (!disabled) choose(event.dataTransfer.files[0]); }}
        className="border-2 border-dashed border-gray-300 rounded-lg p-5 sm:p-8 text-center hover:border-[#E30022] transition-colors">
        <input ref={input} id="cv-file" data-testid="cv-file-input" type="file" accept=".pdf,.doc,.docx" disabled={disabled}
          onChange={event => choose(event.target.files[0])} className="sr-only peer" aria-describedby="cv-file-help" />
        <label htmlFor="cv-file" data-testid="cv-file-picker" className="block cursor-pointer peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-[#E30022]">
          {file ? <><FileText className="h-8 w-8 text-[#E30022] mx-auto mb-3" /><span data-testid="cv-file-name" className="block break-all text-gray-700">{file.name}</span></> : <><Upload className="h-10 w-10 text-gray-400 mx-auto mb-3" /><span className="text-gray-600">Choisissez ou glissez votre CV ici</span></>}
        </label>
        <p id="cv-file-help" data-testid="cv-file-help" className="text-sm text-gray-500 mt-2">PDF, DOC, DOCX · 5 Mo maximum</p>
        {file && <button type="button" data-testid="cv-file-remove" disabled={disabled} onClick={() => { onChange(null); input.current.value = ''; }} className="inline-flex items-center gap-1 text-sm text-[#E30022] mt-3 hover:underline"><X className="h-4 w-4" />Retirer le fichier</button>}
      </div>
      {error && <p role="alert" data-testid="cv-file-error" className="text-red-700 mt-2 text-sm">{error}</p>}
    </div>
  );
};